export const SET_CHANNEL_SOURCES = 'SET_CHANNEL_SOURCES'
export const SET_FEEDBACK_CODES = 'SET_FEEDBACK_CODES'
export const SET_LANGUAGES = 'SET_LANGUAGES'
export const SET_SUBJECTS = 'SET_SUBJECTS'
export const SET_KNOWLEDGE_QUESTION_TYPES = 'SET_KNOWLEDGE_QUESTION_TYPES'
export const SET_RELATION_TYPES = 'SET_RELATION_TYPES'
export const SET_SKILL_TYPES = 'SET_SKILL_TYPES'
export const SET_QUESTION_TYPES = 'SET_QUESTION_TYPES'
export const SET_ORG_LIST = 'SET_ORG_LIST'
export const SET_ZONE_LIST = 'SET_ZONE_LIST'
export const SET_QUESTION_RELATION_TYPES = 'SET_QUESTION_RELATION_TYPES'
export const SET_PROMPT_TPL = 'SET_PROMPT_TPL'
export const SET_EXERCISES = 'SET_EXERCISES'
export const SET_EXERCISE_TYPE = 'SET_EXERCISE_TYPE'
export const SET_AREA = 'SET_AREA'
export const SET_KV = 'SET_KV'
export const SET_CONSTANTS = 'SET_CONSTANTS'
export const SET_QUESTION = 'SET_QUESTION'


